import { StatusPill } from "../../../shared/ui/status-pill";
import { ActionsCell, VerButton } from "../../alert-management/ui/table.styles";

const wrapColumnTitle = (...lines) => (
  <span
    style={{
      display: "inline-block",
      width: "100%",
      whiteSpace: "normal",
      lineHeight: 1.15,
      textAlign: "center",
    }}
  >
    {lines.map((line, index) => (
      <span key={`${line}-${index}`} style={{ display: "block" }}>
        {line}
      </span>
    ))}
  </span>
);

const PILL_TOKENS = {
  neutral: { background: "#F3F4F6", border: "#D1D5DB", color: "#374151" },
  blue: { background: "#E0F2FE", border: "#7DD3FC", color: "#075985" },
  cyan: { background: "#DDFBFB", border: "#6EE7E7", color: "#155E75" },
  green: { background: "#DCFCE7", border: "#86EFAC", color: "#166534" },
  amber: { background: "#FEF3C7", border: "#FCD34D", color: "#92400E" },
  orange: { background: "#FFEDD5", border: "#FDBA74", color: "#9A3412" },
  red: { background: "#FEE2E2", border: "#FCA5A5", color: "#991B1B" },
  violet: { background: "#EDE9FE", border: "#C4B5FD", color: "#5B21B6" },
};

const CATALOG_PILL_TONES = ["blue", "cyan", "amber", "violet", "green", "orange", "red"];

const buildCatalogPillMap = (options = []) =>
  Object.fromEntries(
    options.map((opt, index) => [
      opt.value,
      CATALOG_PILL_TONES[index % CATALOG_PILL_TONES.length],
    ])
  );

const renderPill = (label, tone = "neutral") => {
  const tokens = PILL_TOKENS[tone] || PILL_TOKENS.neutral;
  return (
    <StatusPill
      backgroundColor={tokens.background}
      borderColor={tokens.border}
      textColor={tokens.color}
      minHeight="28px"
      padding="4px 12px"
      fontSize="12px"
      fontWeight={800}
      uppercase
    >
      {label || "NO DEFINIDO"}
    </StatusPill>
  );
};

const wrapCell = {
  onCell: () => ({
    style: { whiteSpace: "normal", wordBreak: "break-word", verticalAlign: "top" },
  }),
};

const renderText = (value) => value || "---";

export const getCentralizationColumns = (
  managementTypeOptions = [],
  alertManagementOptions = [],
  { onDetails } = {}
) => {
  const managementTypePillMap = buildCatalogPillMap(managementTypeOptions);
  const alertManagementPillMap = buildCatalogPillMap(alertManagementOptions);

  return [
    {
      title: "Jornada",
      dataIndex: "jornada",
      key: "jornada",
      width: 130,
      align: "center",
      render: renderText,
      ...wrapCell,
    },
    {
      title: wrapColumnTitle("N°", "Orden"),
      dataIndex: "ordenNumero",
      key: "ordenNumero",
      width: 110,
      align: "center",
      render: renderText,
      ...wrapCell,
    },
    {
      title: "CUB",
      dataIndex: "cub",
      key: "cub",
      width: 110,
      align: "center",
      render: renderText,
      ...wrapCell,
    },
    {
      title: "Titular",
      dataIndex: "documentoTitular",
      key: "documentoTitular",
      width: 130,
      align: "center",
      render: renderText,
      ...wrapCell,
    },
    {
      title: "Proveedor",
      dataIndex: "supplier",
      key: "supplier",
      width: 180,
      align: "center",
      render: renderText,
      ...wrapCell,
    },
    {
      title: wrapColumnTitle("ID", "Producto"),
      dataIndex: "productId",
      key: "productId",
      width: 90,
      align: "center",
      render: renderText,
    },
    {
      title: "Producto",
      dataIndex: "productName",
      key: "productName",
      width: 200,
      align: "center",
      render: renderText,
      ...wrapCell,
    },
    {
      title: wrapColumnTitle("Tipo", "gestión"),
      dataIndex: "managementType",
      key: "managementType",
      width: 160,
      align: "center",
      render: (value, record) =>
        renderPill(value, managementTypePillMap[record?.managementTypeCode]),
    },
    {
      title: wrapColumnTitle("Gestión", "alerta"),
      dataIndex: "alertManagement",
      key: "alertManagement",
      width: 160,
      align: "center",
      render: (value, record) =>
        renderPill(value, alertManagementPillMap[record?.alertManagementCode]),
    },
    {
      title: "Acciones",
      key: "actions",
      width: 140,
      align: "center",
      fixed: "right",
      render: (_, record) => (
        <ActionsCell>
          <VerButton onClick={() => onDetails?.(record)}>Detalles</VerButton>
        </ActionsCell>
      ),
    },
  ];
};